import React from "react";

export default function PageHero({ eyebrow, title, description, children, accent = "blue" }) {
  return (
    <section data-testid="page-hero" className="relative pt-32 pb-20 overflow-hidden">
      <div className="absolute inset-0 grid-bg opacity-60" />
      <div className="absolute inset-0 radial-glow" />
      <div className="relative container-cd">
        <div className="max-w-3xl">
          {eyebrow && <span className="badge-cd" data-testid="page-hero-eyebrow">{eyebrow}</span>}
          <h1 className="mt-5 font-display text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tight text-[#0A1B5E] leading-[1.05]">
            {title}
          </h1>
          {description && (
            <p className="mt-6 text-lg text-slate-600 leading-relaxed max-w-2xl">{description}</p>
          )}
          {children && <div className="mt-8">{children}</div>}
        </div>
      </div>
      <div className={`pointer-events-none absolute -top-10 right-0 w-[480px] h-[480px] rounded-full blur-3xl ${accent === "purple" ? "bg-purple-300/30" : "bg-cyan-300/30"}`} />
    </section>
  );
}
